import Image from 'next/image';
import Link from 'next/link';
import { cn } from '@/app/utils';
import type { Template } from '../types';

interface TemplateCardProps {
  template: Template;
  className?: string;
  priority?: boolean;
}

export default function TemplateCard({ template, className, priority = false }: TemplateCardProps) {
  return (
    <Link
      href={`/ai-templates/${template.slug}`}
      prefetch={false}
      className={cn(
        'block overflow-hidden rounded-[20px] border border-black/10 bg-white/10 shadow-[0_3.419px_6.838px_0_rgba(0,0,0,0.02),_0_5.129px_10.257px_0_rgba(0,0,0,0.03)] sm:rounded-12',
        className,
      )}
    >
      <div className="relative aspect-video">
        <Image
          src={template.cover}
          alt={template.title}
          fill
          className="object-cover"
          loading={priority ? undefined : 'lazy'}
          decoding="async"
          priority={priority}
        />
      </div>
      <h3 className="truncate p-4 font-semibold text-[18px] text-white sm:text-sm">{template.title}</h3>
    </Link>
  );
}
